import { Component, Watch, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentPriceTable } from '../../../components/apartment-price-table/apartment-price-table';
import { ApartmentSearchStatsDTO } from '../../../model/ApartmentSearchStatsDTO';
import { ApartmentSearchDTO } from '../../../model/ApartmentSearchDTO';
import { ApartmentSearchSortType } from '../../../enums/ApartmentSearchSortType';
import { LocationDTO } from '../../../model/LocationDTO';
import { ApartmentSearchFilterDTO } from '@/model/ApartmentSearchFilterDTO';
import { ApartmentSearchSortDirection } from '../../../enums/ApartmentSearchSortDirection';
import { formatDateLocal } from '@/helpers/dates';

@Block()
@Component({
	components: {
		ApartmentPriceTable
	}
})
export class ApartmentsOverviewResultBlock extends BaseBlock {
	@Prop() location: LocationDTO;

	results: ApartmentSearchDTO[] = null;
	nextStats: ApartmentSearchStatsDTO = null;
	limit = 50;
	offset = 0;

	fetchingResults: boolean = false;

	@Watch('$route', {immediate: true})
	protected searchFilterChanged() {
		if (this.shouldSearch) {
			this.load();
		}
	}

	load() {
		this.results = null;

		this.limit = 50;
		this.offset = 0;
		this.fetchResults();
	}

	loadMore() {
		this.offset += this.limit;
		this.fetchResults(true);
	}

	get shouldSearch() {
		return this.$route.query.search === 'true';
	}

	get searchFilter() {
		return {
			...this.$route.query,
			locationIds: [this.location.id],
			locationCatNo: [this.location.catalogMarketingNumber],
		} as ApartmentSearchFilterDTO;
	}

	get searchSort() {
		return parseInt(this.$route.query.sort) as ApartmentSearchSortType || ApartmentSearchSortType.TotalPrice;
	}

	get searchSortDirection() {
		return parseInt(this.$route.query.sortDirection) as ApartmentSearchSortDirection || ApartmentSearchSortDirection.Up;
	}

	get currentDateFormated() {
		return formatDateLocal(this.getCurrentDate());
	}

	async fetchResults(append: boolean = false) {
		this.fetchingResults = true;

		const results = await this.$apartmentService.fetchApartments(
			this.searchFilter,
			this.searchSort,
			this.searchSortDirection,
			this.limit,
			this.offset
		);

		const nextStats = await this.$apartmentService.fetchSearchStats(
			this.searchFilter,
			this.limit,
			this.offset + this.limit
		);

		if (append) {
			this.results = this.results.concat(results);
		} else {
			this.results = results;
		}

		this.nextStats = nextStats;

		this.fetchingResults = false;
	}
}

export default ApartmentsOverviewResultBlock;
